import { Map as map } from 'immutable';
const C = require("../constants");

function IngredientStockReducer(state = map(), action) {
    switch (action.type) {
        case C.INGREDIENTS_STOCK:
            return action.ingredients_stock;
        case C.INGREDIENTS_STOCK_UPDATE:
            return state.map((ingredient_stock)=> {
                if(ingredient_stock.id === action.ingredient_stock.id ) {
                    return action.ingredient_stock
                } else {
                    return ingredient_stock;
                }
            });
        default:
            return state;
    }
}

export default IngredientStockReducer;


// WEBPACK FOOTER //
// ./src/reducers/IngredientStockReducer.js